import { useEffect, useState } from 'react';

const LINES = [
  { t: '// Who is APPSHELL?', c: 'comment' },
  { t: '', c: 'blank' },
  { t: ['const', ' appshell', ' = {'], c: 'decl' },
  { t: ['  name:', " 'APPSHELL LLC',"], c: 'prop' },
  { t: ['  founded:', ' 2026,'], c: 'prop-num' },
  { t: ['  hq:', " 'Sheridan, Wyoming 🇺🇸',"], c: 'prop' },
  { t: ['  mission:', " 'Build software people love',"], c: 'prop' },
  { t: ['  focus:', " 'iOS — because details matter',"], c: 'prop' },
  { t: ['  contact:', " 'hello@appshell.co',"], c: 'prop' },
  { t: '};', c: 'decl' },
];

function renderLine(line, typedLen) {
  if (typeof line.t === 'string') {
    const text = line.t.slice(0, typedLen);
    if (line.c === 'comment') return <span className="tk-comment">{text}</span>;
    if (line.c === 'decl') return <span className="tk-decl">{text}</span>;
    return <span>{text}</span>;
  }
  const [key, val] = line.t;
  if (typedLen <= key.length) {
    return <span className="tk-key">{key.slice(0, typedLen)}</span>;
  }
  const valShown = val.slice(0, typedLen - key.length);
  const valClass = line.c === 'prop-num' ? 'tk-num' : 'tk-str';
  return (
    <>
      <span className="tk-key">{key}</span>
      <span className={valClass}>{valShown}</span>
    </>
  );
}

function lineLength(line) {
  if (typeof line.t === 'string') return line.t.length;
  return line.t[0].length + line.t[1].length;
}

export default function About({ onNavigate }) {
  const [lineIdx, setLineIdx] = useState(0);
  const [charIdx, setCharIdx] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (lineIdx >= LINES.length) {
      setDone(true);
      return;
    }
    const line = LINES[lineIdx];
    const total = lineLength(line);
    if (charIdx >= total) {
      const delay = line.c === 'blank' ? 80 : 180;
      const id = setTimeout(() => {
        setLineIdx((i) => i + 1);
        setCharIdx(0);
      }, delay);
      return () => clearTimeout(id);
    }
    const speed = line.c === 'comment' ? 22 : 28;
    const id = setTimeout(() => setCharIdx((c) => c + 1), speed);
    return () => clearTimeout(id);
  }, [lineIdx, charIdx]);

  return (
    <main className="page about">
      <nav className="nav">
        <button className="nav-back" onClick={() => onNavigate('home')}>
          <div className="logo-mark" aria-hidden="true">
            <span className="logo-dot" />
          </div>
          <span className="logo-word mono">APPSHELL</span>
        </button>
        <button className="nav-contact back-link" onClick={() => onNavigate('home')}>
          ← Back
        </button>
      </nav>

      <section className="about-hero">
        <div className="about-pill about-pill-static" aria-hidden="true">
          <span className="pill-dot" />
          <span>About Us</span>
        </div>
        <h2 className="about-heading">
          A small studio with a <em>large</em> sense of craft.
        </h2>
      </section>

      <section className="code-window">
        <div className="code-top">
          <span className="code-dot code-dot-r" />
          <span className="code-dot code-dot-y" />
          <span className="code-dot code-dot-g" />
          <span className="code-file mono">appshell.config.js</span>
        </div>
        <pre className="code-body mono">
          {LINES.map((line, i) => {
            const isCurrent = i === lineIdx && !done;
            const isPast = i < lineIdx || done;
            const len = isPast ? lineLength(line) : isCurrent ? charIdx : 0;
            return (
              <div className="code-line" key={i}>
                <span className="code-ln">{String(i + 1).padStart(2, ' ')}</span>
                <span className="code-text">
                  {renderLine(line, len)}
                  {isCurrent && <span className="caret" />}
                </span>
              </div>
            );
          })}
          {done && (
            <div className="code-line code-done">
              <span className="code-ln">  </span>
              <span className="code-text tk-comment">{'// shell online ✓'}</span>
            </div>
          )}
        </pre>
      </section>

      <div className="about-back-wrap">
        <button className="btn-back" onClick={() => onNavigate('home')}>
          ← Back to Home
        </button>
      </div>

      <footer className="footer">
        <span className="footer-brand">© 2026 APPSHELL LLC</span>
        <div className="footer-links">
          <button className="footer-link" onClick={() => onNavigate('privacy')}>
            Privacy Policy
          </button>
          <span className="footer-dot">·</span>
          <button className="footer-link" onClick={() => onNavigate('terms')}>
            Terms of Use
          </button>
          <span className="footer-dot">·</span>
          <button className="footer-link" onClick={() => onNavigate('content')}>
            Content Policy
          </button>
        </div>
      </footer>
    </main>
  );
}
